export default __webpack_public_path__ + "b26c2a3e8e08968fd3a076422b8988bf.svg";